function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
const SovosCircularProgress = _ref => {
  let {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(CircularProgress, _extends({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: clsx('sovosCircularProgress', className)
  }, rest));
};
SovosCircularProgress.propTypes = {
  /**
   * Callback fired when Aria attributes are missing or both are present.
   */
  'aria-label': _ref2 => {
    let {
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy
    } = _ref2;
    if (ariaLabel && ariaLabelledBy) {
      return new Error('Do not include both ariaLabel or ariaLabelledBy');
    }
    if (!ariaLabel && !ariaLabelledBy) {
      return new Error('Either aria-label or aria-labelledby is required for accessibility');
    }
    return null;
  },
  /**
   * Use ariaLabelledBy if the label text is available in the DOM and
   * referencing the DOM content.
   */
  'aria-labelledby': string,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosCircularProgress.baseComponent = {
  name: 'Circular Progress',
  link: 'circular-progress/'
};
export default SovosCircularProgress;